import { ref } from 'vue';
import axios from 'axios';
import { route } from 'ziggy-js';
import IPaymentRequest from '@/types/PaymentRequests/IPaymentRequest';

const shouldDisplayProTrialBanner = ref(false);
const shouldDisplayPluginTrialBanner = ref(false);
const shouldDisplayPluginSubscriptionBanner = ref(false);
const shouldDisplayProPersonalSubscriptionBanner = ref(false);
const shouldDisplayProTeamSubscriptionBanner = ref(false);
const shouldDisplayBlackFridayDeal = ref(false);
const shouldDisplayDeletedBanner = ref(false);
const shouldDisplayApiTokensBucketsBlockedBanner = ref(false);
const shouldDisplayLettrPromoTemplateCard = ref(false);
const shouldDisplayLettrPromoBanner = ref(false);
const shouldDisplayLettrPromoSidebar = ref(false);
const latestPaymentRequest = ref<null | IPaymentRequest>(null);

export const useBanners = () => {
    const fetchBanners = async () => {
        try {
            const res = await axios.get(route('user.banners.index'));

            if (res.data.success) {
                shouldDisplayProTrialBanner.value =
                    res.data.data.proTrialBanner;
                shouldDisplayProPersonalSubscriptionBanner.value =
                    res.data.data.proPersonalSubscriptionBanner;
                shouldDisplayProTeamSubscriptionBanner.value =
                    res.data.data.proTeamSubscriptionBanner;
                shouldDisplayPluginTrialBanner.value =
                    res.data.data.pluginTrialBanner;
                shouldDisplayPluginSubscriptionBanner.value =
                    res.data.data.pluginSubscriptionBanner;
                shouldDisplayBlackFridayDeal.value =
                    res.data.data.shouldDisplayBlackFridayDeal;
                shouldDisplayDeletedBanner.value = res.data.data.deletedBanner;
                shouldDisplayApiTokensBucketsBlockedBanner.value =
                    res.data.data.apiTokensBucketsBlockedBanner;
                shouldDisplayLettrPromoTemplateCard.value =
                    res.data.data.lettrPromoTemplateCard;
                shouldDisplayLettrPromoBanner.value =
                    res.data.data.lettrPromoBanner;
                shouldDisplayLettrPromoSidebar.value =
                    res.data.data.lettrPromoSidebar;
            }
        } catch (err) {
            return;
        }
    };

    const fetchPaymentRequestData = async () => {
        try {
            const res = await axios.get(
                route('user.payment-request-latest.index')
            );

            if (res.data.success) {
                latestPaymentRequest.value = res.data.data;
            }
        } catch (err) {
            return;
        }
    };

    return {
        fetchBanners,
        shouldDisplayProTrialBanner,
        shouldDisplayProPersonalSubscriptionBanner,
        shouldDisplayProTeamSubscriptionBanner,
        shouldDisplayPluginTrialBanner,
        shouldDisplayPluginSubscriptionBanner,
        shouldDisplayDeletedBanner,
        shouldDisplayApiTokensBucketsBlockedBanner,
        shouldDisplayBlackFridayDeal,
        shouldDisplayLettrPromoTemplateCard,
        shouldDisplayLettrPromoBanner,
        shouldDisplayLettrPromoSidebar,
        fetchPaymentRequestData,
        latestPaymentRequest,
    };
};

export default useBanners;
